import React from "react";
import { BrutalButton } from "../../components/ui/BrutalButton";
import { pictures } from "../../data/lessonContent";
const beliefs = [{
  title: "Your first language is an asset.",
  body: "Explaining Spanish to a Russian speaker isn't the same as explaining it to an English speaker. So we don't pretend it is."
}, {
  title: "The words you need beat the words we pick.",
  body: "A translator that feeds your lessons means the vocabulary you actually looked up becomes the vocabulary you actually know."
}, {
  title: "Games are for practice. Books are for understanding.",
  body: "Short games make repetition painless. The textbook explains why the sentence works. You need both."
}, {
  title: "Streaks should feel good, not guilty.",
  body: "We celebrate showing up, and we let you pause without punishment."
}];
export function About() {
  return <div className="mx-auto max-w-6xl px-5 py-16 md:px-8 md:py-24" data-id="element-1735" data-mp="3mfgorioyjz22">
      <header className="grid gap-10 md:grid-cols-[1.2fr_1fr] md:items-end" data-id="element-1736" data-mp="3qfqs0nld8bd8">
        <h1 className="text-[clamp(40px,6.5vw,80px)] font-bold leading-[1.02] tracking-[-0.02em]" data-id="element-1737" data-mp="342izjvhnu521">
          We think in one language and dream in a few more.
        </h1>
        <p className="text-[17px] leading-relaxed text-ink-2" data-id="element-1738" data-mp="2uchezdoin4rv">
          PolyLexa started in a Milan classroom where half the students spoke Ukrainian, a third spoke Spanish, and every textbook assumed they all
          spoke English. We built the app we wished they'd had.
        </p>
      </header>

      <img src={pictures.market} alt="Illustration of a lively fruit market — a scene from our Spanish course book" className="mt-14 aspect-[21/9] w-full rounded-panel border-3 border-line object-cover shadow-brutal-lg" data-id="element-1739" data-mp="3i2bn5hxw455s" />

      <section aria-labelledby="beliefs-title" className="mt-24 grid gap-10 md:grid-cols-[1fr_1.6fr]" data-id="element-1740" data-mp="383cngov3rjux">
        <h2 id="beliefs-title" className="text-3xl font-bold tracking-[-0.02em] md:text-4xl" data-id="element-1741" data-mp="21p3n3tzoczem">
          What we believe
        </h2>
        <dl className="divide-y-3 divide-line border-y-3 border-line" data-id="element-1742" data-mp="opa62yx4xzny">
          {beliefs.map(b => <div key={b.title} className="py-6" data-id="element-1743" data-mp="sqlookhldkmn">
              <dt className="text-xl font-bold tracking-[-0.01em]" data-id="element-1744" data-mp="sqbxitkt97fd">{b.title}</dt>
              <dd className="mt-2 max-w-[56ch] text-[17px] leading-relaxed text-ink-2" data-id="element-1745" data-mp="eq169pfl9qto">{b.body}</dd>
            </div>)}
        </dl>
      </section>

      <section aria-labelledby="partner-title" className="mt-24 rounded-blob border-3 border-line bg-brand-tint p-8 md:p-14" data-id="element-1746" data-mp="51auxmynsqi0">
        <h2 id="partner-title" className="max-w-[22ch] text-3xl font-bold leading-tight tracking-[-0.02em] md:text-4xl" data-id="element-1747" data-mp="9s9dyub182oy">
          Built with Loescher Editore
        </h2>
        <p className="mt-4 max-w-[60ch] text-[17px] leading-relaxed text-ink-2" data-id="element-1748" data-mp="zpbfirmddyu">
          Loescher has published language textbooks for Italian schools for generations. Together we adapt their chapters into course pairs — the
          same story you read in the book is the one you practise in the games.
        </p>
        <div className="mt-8 flex flex-wrap gap-4" data-id="element-1749" data-mp="33kklhykrpxds">
          <BrutalButton to="/auth/signup" data-id="element-1750" data-mp="33ldwxcuo9b29">Start learning</BrutalButton>
          <BrutalButton to="/contact" variant="surface" data-id="element-1751" data-mp="2zkk6octrbk67">
            Talk to us
          </BrutalButton>
        </div>
      </section>
    </div>;
}